import { CheckCircle, ShieldCheck } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const commitments = [
  ["Clear accountability", "Every job starts with defined scope, contacts, and operating expectations."],
  ["Respect on deck", "A professional work environment built on dignity, direct communication, and teamwork."],
  ["Standards in practice", "Procedures shaped around responsible marine operations and continuous improvement."],
];

export const Safety = () => (
  <section id="safety" className="safety-section" data-testid="safety-section">
    <div className="safety-image-wrap">
      <img
        src="https://images.pexels.com/photos/31727389/pexels-photo-31727389.jpeg?auto=compress&cs=tinysrgb&w=1600"
        alt="Towboat moving a working barge formation along an inland waterway"
        data-testid="safety-image"
      />
      <div className="safety-stamp" data-testid="safety-priority-stamp">
        <ShieldCheck size={34} weight="fill" /><span>Safety is<br />the standard</span>
      </div>
    </div>
    <motion.div
      className="safety-copy"
      initial={{ opacity: 0, x: 28 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.65 }}
    >
      <span className="eyebrow light" data-testid="safety-label">02 / Responsibility</span>
      <h2 data-testid="safety-heading">Do the work right.<br /><em>Every time.</em></h2>
      <p className="safety-lead" data-testid="safety-introduction">
        Reliability on the water begins long before the first line is handled. It starts with integrity, preparation, and respect for people and place.
      </p>
      <div className="commitment-list" data-testid="safety-commitments-list">
        {commitments.map(([title, text], index) => (
          <div className="commitment" key={title} data-testid={`safety-commitment-${index + 1}`}>
            <CheckCircle size={25} weight="fill" />
            <div><h3>{title}</h3><p>{text}</p></div>
          </div>
        ))}
      </div>
    </motion.div>
  </section>
);